import { Injectable } from '@angular/core';
import Shepherd from 'shepherd.js';
import { Tour } from 'shepherd.js';
import { AppTourStep } from '../models/tour-step.model';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root',
})
export class TourService {
  private tour: Tour;
  public startServiceTour = new Subject<void>();

  constructor( private translate: TranslateService) {
    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        cancelIcon: { enabled: true },
        classes: 'shepherd-theme-arrows',
        scrollTo: true,
        scrollToHandler: (element) => {
          const yOffset = -100; // adjust for your sticky header height
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }

    });
  }

  public initializeTour(steps: AppTourStep[], page?:string) {
    // Reset the tour completely before adding new steps
    if (this.tour) {
      this.tour.cancel();
    }

    // Recreate a new Tour instance
    this.tour = new Shepherd.Tour({
      useModalOverlay: true,
      defaultStepOptions: {
        scrollTo: true,
        cancelIcon: { enabled: true },
        classes: 'shepherd-theme-arrows',
         scrollToHandler: (element) => {
          const header = document.querySelector('.side-menu-header') as HTMLElement;
          const headerHeight = header ? header.offsetHeight : 0;
        
          // Find the closest scrollable parent
          const getScrollParent = (el: HTMLElement | null): HTMLElement | Window => {
            while (el) {
              const style = window.getComputedStyle(el);
              const overflowY = style.overflowY;
              if ((overflowY === 'auto' || overflowY === 'scroll') && el.scrollHeight > el.clientHeight) {
                return el;
              }
              el = el.parentElement;
            }
            return window;
          };
        
          const scrollParent = getScrollParent(element) as HTMLElement | Window;
        
          const rect = element.getBoundingClientRect();
          let parentRect: DOMRect;
        
          if (scrollParent instanceof Window) {
            parentRect = document.documentElement.getBoundingClientRect();
          } else {
            parentRect = scrollParent.getBoundingClientRect();
          }
        
          let targetScroll: number;
        
          if (rect.top < parentRect.top + headerHeight) {
            // Element is hidden behind sticky header → scroll up
            targetScroll =
              (scrollParent instanceof Window ? window.pageYOffset : scrollParent.scrollTop) +
              (rect.top - parentRect.top) -
              headerHeight -
              10;
          } else if (rect.bottom > parentRect.bottom) {
            // Element is below viewport → scroll down
            targetScroll =
              (scrollParent instanceof Window ? window.pageYOffset : scrollParent.scrollTop) +
              (rect.bottom - parentRect.bottom) +
              10;
          } else {
            return; // Already visible
          }
        
          if (scrollParent instanceof Window) {
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const maxScroll = document.documentElement.scrollHeight - viewportHeight;
            window.scrollTo({ top: Math.min(targetScroll, maxScroll), behavior: 'smooth' });
          } else {
            const maxScroll = scrollParent.scrollHeight - scrollParent.clientHeight;
            scrollParent.scrollTo({ top: Math.min(targetScroll, maxScroll), behavior: 'smooth' });
          }
        }       
      },
    });

    steps.forEach((step) => {
      this.tour.addStep({
        id: step.id,
        text: step.text,
        attachTo: step.attachTo,
        buttons: step.buttons || this.getDefaultButtons(),
        ...(step.when && { when: step.when })
      });
    });
  }

  public startTour() {
    this.tour.start();
  }

  private getDefaultButtons() {
    return [
      {
        text: this.translate.instant('Back'),
        action: this.tour.back,
        classes: 'btn-next'
      },
      {
        text: this.translate.instant('Next'),
        action: this.tour.next,
        classes: 'btn-next'
      },
      {
        text: this.translate.instant('Skip'),
        action: this.tour.complete,
        classes: 'btn-next'
      },
    ];
  }


  startSidebarTour(): void {
    const steps: AppTourStep[] = [
      {
        id: 'dashboard',
        text: this.translate.instant('tour.dashboard'),
        attachTo: {
          element: '.shepherd-dashboard',
          on: 'right'
        }
      },
      /*{
        id: 'customer-management',
        text: 'Manage all your customers from here.',
        attachTo: {
          element: '.shepherd-user',
          on: 'right'
        }
      },*/
      {
        id: 'services',
        text: this.translate.instant('tour.services'),
        attachTo: {
          element: '.shepherd-service',
          on: 'right'
        }
      },

      /* {
        id: 'wallet',
        text: this.translate.instant('tour.wallet'),
        attachTo: { element: '.shepherd-wallet', on: 'right' }
      }, */
      /*{
        id: 'pricing',
        text: 'View or manage your pricing structure here.',
        attachTo: { element: '.shepherd-price', on: 'right' }
      },*/
      {
        id: 'projects',
        text: this.translate.instant('tour.projects'),
        attachTo: { element: '.shepherd-project', on: 'right' }
      },


      {
        id: 'contracts',
        text: this.translate.instant('tour.contracts'),
        attachTo: { element: '.shepherd-contract', on: 'right' }
      },
      
      /*{
        id: 'primers',
        text: 'Manage your primer configurations here.',
        attachTo: { element: '.shepherd-primer', on: 'right' }
      },*/
      {
        id: 'discounts',
         text: this.translate.instant('tour.discounts'),
        attachTo: {
          element: '.shepherd-discount',
          on: 'right'
        }
      },
      
    ];

    this.initializeTour(steps);
    this.startTour();
  }

  public isActive(): boolean {
    return !!this.tour && this.tour.isActive();
  }


  
  
}
